import { UserLayout } from "@/src/layouts/UserLayout";
import { PendingAirdrop, PendingAirdrop2, PendingAirdrop3 } from "@/src/views/home";

export const Airdrops = () => {
  return (
    <UserLayout>
      <div className="max-w-5xl w-full mx-auto p-4 sm:p-5 lg:p-8 space-y-6">
        <h1 className="text-2xl font-bold text-foreground">Airdrops</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <PendingAirdrop />
          <PendingAirdrop2 />
          <PendingAirdrop3 />
        </div>
      </div>
    </UserLayout>
  );
};
